/* ──────────────────────────────────────────────────────────────
 *  Expected Test Values API — backend-driven computation
 * ────────────────────────────────────────────────────────────── */

import axiosClient from './axiosClient';

export interface ExpectedTestValuesPayload {
  bushing_type: string;
  material: string;
  shore_a: number;
  sleeve_thickness: number;
  CxA: number;
  CzA: number;
  TorA: number;
  sample: Record<string, unknown>;
}

export interface ExpectedTestValuesResponse {
  Cx: number | null;
  Cz: number | null;
  Torsion: number | null;
  Conical: number | null;
}

/**
 * Compute expected physical test values for a sample via the backend.
 *
 * Calls POST /compute/expected-test-values which runs the Levenberg-Marquardt
 * inverse solver on the server side.
 */
export async function computeExpectedTestValues(
  payload: ExpectedTestValuesPayload,
  options?: { signal?: AbortSignal },
): Promise<ExpectedTestValuesResponse> {
  const { data } = await axiosClient.post<ExpectedTestValuesResponse>(
    '/compute/expected-test-values',
    payload,
    { signal: options?.signal },
  );
  return data;
}
